var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEpisodeSite = function SvgEpisodeSite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.956 3H9.728c-.19 0-.344.146-.344.324v.648H6.286c-.19 0-.344.145-.344.324v.647H2.844c-.19 0-.344.146-.344.324v10.041c0 .179.155.324.344.324h3.098v.648c0 .178.155.324.344.324h3.098v.648c0 .178.155.324.344.324h7.228c.19 0 .344-.146.344-.324V3.324c0-.178-.155-.324-.344-.324M5.942 14.985H3.188V5.59h2.754zm3.442.971H6.63V4.62h2.754z"
  })));
};
export default SvgEpisodeSite;